import store from '../store';
import axios from 'axios';
import router from '../router';
import urls from '../urls/config';
import config from '../config';
import candidateFunctions from './CandidateFunctions';

export default {
	capitalizeFLetter( str ) {
		return str[0].toUpperCase() +
			str.slice(1);
	},
	setHeadings( headings ) {
		document.title = headings.title ? headings.title + ' - ' +
			this.getTranslation(config.siteTitle) : this.getTranslation(
			config.siteTitle);
		this.$store.dispatch('heading/setHeadings', headings);

	},
	setDocumentTitle( title ) {
		document.title = title || this.getTranslation(config.siteTitle);
	},
	getImageInfo( image ) {

		return new Promise(( resolve => {
			let imageInfo = {
				name: '',
				extension: '',
				base64: '',
				height: '',
				width: '',
				type: '',
				imageUrl: '',
			};
			imageInfo.name = image.name;
			imageInfo.extension = image.name.split('.').pop();

			let fileType = '';
			if ( imageInfo.extension === 'jpg' )
				fileType = 'jpeg';
			else
				fileType = imageInfo.extension.toLowerCase();

			imageInfo.type = fileType;

			let fileReader = new FileReader();

			fileReader.readAsDataURL(image);

			fileReader.onload = evt => {
				let img = new Image();
				img.onload = () => {
					imageInfo.height = img.height;
					imageInfo.width = img.width;
				};
				img.src = evt.target.result;

				imageInfo.imageUrl = evt.target.result;
				imageInfo.base64 = evt.target.result.replace(
					'data:image/' + fileType + ';base64,', '');

				return resolve(imageInfo);
			}
			;
			fileReader.onerror = evt => {
				console.error(evt);
			};

		} ));
	},


	errorAskAdmin(timer=5000)
	{
		this.$snotify.error('Произошла ошибка обратитесь к администратору',{
			timeout: 5000,
		});
	},

	/*snotify controller*/
	snotifySuccess( msg, timer = 2000 ) {
		if ( !msg )
			return this.$snotify.success(this.getTranslation('saveSuccessMsg'),
				{
					timeout: timer,
				});

		if ( !this.getTranslation(msg) )
			return this.$snotify.success(msg, {
				timeout: timer,
			});

		return this.$snotify.success(this.getTranslation(msg), {
			timeout: timer,
		});
	},
	snotifyError( msg, count = null, timer = 2000 ) {
		if ( !msg )
			return this.$snotify.error(this.getTranslation('serverError'), {
				timeout: timer,
			});
		if ( !this.getTranslation(msg) )
			return this.$snotify.error(msg, {
				timeout: timer,
			});

		return this.$snotify.error(this.getTranslation(msg, count), {
			timeout: timer,
		});
	},
	snotifyWarning( msg, count = null, timer = 2000 ) {
		if ( !msg )
			return this.$snotify.warning(this.getTranslation('warning', count),
				{
					timeout: timer,
				});
		if ( !this.getTranslation(msg) )
			return this.$snotify.warning(msg, {
				timeout: timer,
			});

		return this.$snotify.warning(this.getTranslation(msg, count), {
			timeout: timer,
		});
	},

	// object helpers
	objectToArray( obj, keyToInt, translate = false ) {
		if ( typeof obj !== 'object' ) return obj;

		if ( translate )
			return Object.keys(obj).map(key => {
				return {
					id: keyToInt ? Number.parseInt(key) : key,
					title: this.getTranslation(obj[key]),
				};
			});

		return Object.keys(obj).map(key => {
			return {
				id: keyToInt ? Number.parseInt(key) : key,
				title: obj[key],
			};
		});
	},
	objectToOnlyValueArray( obj ) {
		return Object.keys(obj).map(key => {
			return obj[key];
		});
	},

	makeId( length ) {
		let result = '';
		let characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789abcdefghijklmnopqrstuvwxyz';
		let charactersLength = characters.length;
		for ( let i = 0; i < length; i++ ) {
			result += characters.charAt(
				Math.floor(Math.random() * charactersLength));
		}
		return result;
	},
	hasPermission( permission ) {

		if ( permission && store.getters['user/getPermissions'] )
			return store.getters['user/getPermissions'].indexOf(permission) >
				-1;

		return false;
	},
	setAxiosAuthorization(bearer=true) {
		axios.defaults.headers.common['Authorization'] = this.getUserToken(bearer);
	},

	getUserToken( bearer = true ) {

		let authToken = localStorage.getItem('auth_token');

		let token = 'Bearer ' + authToken;

		if ( bearer )
			return token;

		return authToken;
	},

	loadUser( loadPermission = false ) {

		let token = this.getUserToken(false);

		if ( token ) {

			axios.defaults.headers.common['Authorization'] = this.getUserToken();

			if ( !store.getters['user/getUserId'] || loadPermission )
				return axios.get(urls.user.getRequestUser.url).
					then(response => {
						store.dispatch('user/setUser', response.data.data);
						return response.data.data;
					}).
					catch(() => {
						return this.removeUserInfo();
					});
		} else {
			return this.removeUserInfo();
		}

		return new Promise(resolve => true);

	},
	isAdmin() {
		if ( !store.getters['user/getUserId'] ) {
			let user = this.loadUser();
			return !!user.isAdmin;
		}

		return !!store.getters['user/isAdmin'];
	},
	async logout() {
		return this.removeUserInfo(false).then(async () => {
			await this.setAxiosAuthorization(false);
			router.replace({ name: 'admin.login' }).catch(() => {
			});
		});
	},

	async removeUserInfo( redirect = true ) {

		if ( localStorage.getItem('locale') === 'ru_RU' )
			this.setDocumentTitle('Тестирование');
		else
			this.setDocumentTitle('Сынак');

		await localStorage.removeItem('auth_token');

		await store.dispatch('user/resetUser');

		if ( redirect )
			router.replace({ name: 'admin.login' }).catch(() => {
			});

		return new Promise(( resolve, reject ) => {
			this.setAxiosAuthorization(false);
			resolve(true);
		});
	},

	page422Handler( error ) {
		let res = Object.assign({}, error).response;

		let hasMessage = false;

		if ( res ) {

			if ( res.data.data )

				for ( let arr in res.data.data ) {
					if ( res.data.data.hasOwnProperty(arr) )

						if ( res.data.data[arr].hasOwnProperty(
							'callbackValue') )

							this.$snotify.error(
								res.data.data[arr].callbackValue);

						else if ( res.data.data[arr].hasOwnProperty('isEmpty') )

							this.$snotify.error(res.data.data[arr].isEmpty);

						else
							for ( let msg of res.data.data[arr] )
								this.$snotify.error(msg);

					hasMessage = true;
				}

			if ( res.data.message ) {
				hasMessage = true;
				return this.$snotify.error(res.data.message);
			}

			if ( !hasMessage ) this.$snotify.error(res.data.message);
		}

	},

	page451Handler( error ) {
		let res = Object.assign({}, error).response;

		if ( res && res.data.message )

			Swal.fire({
				icon: 'error',
				title: this.getTranslation(res.data.message),
			});

	},

	addSeconds( time ) {
		let fullTimeFormat = '00:00:00';
		let timeFormat = '00:00';
		if ( time.length !== fullTimeFormat.length && time.length ===
			timeFormat.length )
			return time + ':00';
		else
			return time;
	},

	loadLocale() {

		let params = {
			lang: 'ru_RU',
		};

		let locale = localStorage.getItem('locale');
		let candidateLocale = localStorage.getItem('testingLocale');

		if ( candidateLocale &&
			this.$store.getters['candidate/getCandidateId'] ) {
			this.changeLocale(candidateLocale, true);
		} else {
			if ( locale )
				params.lang = locale;

			axios.get(urls.language.fetchTranslations.url, { params: params }).
				then(response => {

					let lang = response.data.data;

					this.$store.dispatch('language/setLanguage', lang);

					localStorage.setItem('locale', lang.locale);
				}).
				catch(() => {
				});
		}

	},

	fetchLocales() {
		return this.axios.get(this.$config.urls.language.fetchFormOptions.url).
			then(response => {
				this.locales = this.objectToArray(response.data.data.languages);
				this.$store.dispatch('language/setLocales',
					this.objectToArray(response.data.data.languages));
			}).catch(() => {});
	},

	changeLocale: async function( locale, isCandidate = false ) {

		if ( isCandidate ) {
			await this.changeTestingLocale(locale);
		} else if ( this.$store.getters['language/getLanguage'].locale !==
			locale ) {

			let lang = await axios.get(urls.language.fetchTranslations.url,
				{ params: { lang: locale } }).then(response => {
				return response.data.data;
			});

			localStorage.setItem('locale', lang.locale);

			await this.$store.dispatch('language/setLanguage', lang);
		}
	},

	changeTestingLocale: async function( locale ) {
		if ( this.$store.getters['language/getTestingLanguage'] !== locale ) {

			candidateFunctions.loadCandidate(true);

			let lang = await axios.get(urls.language.fetchTranslations.url,
				{ params: { lang: locale } }).then(response => {
				return response.data.data;
			});

			await this.$store.dispatch('language/setTestingLanguage', locale);
			await this.$store.dispatch('language/setLanguage', lang);
			this.setDocumentTitle();
			localStorage.setItem('testingLocale', locale);
		}
	},

	chunkArray( array, size = 4 ) {
		let arr = [];
		while ( array.length > 0 ) {
			arr.push(array.splice(0, size));
		}
		return arr;
	},

	getTranslation( key, count ) {
		if ( !count ) count = 0;
		if ( this.translations && this.translations.hasOwnProperty(key) ) {
			if ( this.translations[key] &&
				this.translations[key].includes('{0}') )
				return this.translations[key].replace('{0}', count);
			return this.translations[key];
		} else
			return this.$lang.languages[key] || key;
	},

	cleanObject( object ) {
		for ( let prop in object ) {
			if ( object.hasOwnProperty(prop) )
				if ( object[prop] === null || object[prop] === undefined ||
					object[prop] === '' )
					delete object[prop];
		}
		return object;
	},

	cleanArray( arr ) {
		let newArr = [];
		for ( let prop of arr )
			if ( prop !== null && prop !== undefined && prop !== '' )
				newArr.push(prop);

		return newArr;
	},

	tabSelect( tabName, option = 'candidates', queryReplace = true ) {
		tabName = tabName || this.tabs[this.$route.query.tab] || option;
		if ( !this.tabs[tabName] )
			for ( let tab in this.tabs ) {
				if ( this.tabs.hasOwnProperty(tab) ) {
					this.tabs[tab] = tabName === tab;
					if ( this.tabs[tab] === true ) {
						if ( queryReplace ) {
							let query = { ...this.$router.query };
							query.tab = tab;
							this.$router.replace({
								query: query,
							}).catch(() => {
							});
						}
					}
				}
			}
	},

	hasUserViewPermission( userId ) {
		let isAdmin = this.$store.getters['user/isAdmin'];
		let viewerId = this.$store.getters['user/getUserId'];

		if ( !this.hasPermission('api.users.get') )
			return false;

		if ( !isAdmin && this.hasPermission('api.users.get') && viewerId !==
			userId )
			return false;

		return true;
	},

	toggleCalendarView() {
		this.$root.$emit('toggleCalendar');
	},

	generateHexColor() {

		return ( '#' + Math.floor(Math.random() * 16777215).toString(16) );
	},

	redirectTo( params ) {

		if ( !params.route )
			return console.error('provide route name');

		this.$router.push(
			{ name: params.route, params: params.params, query: params.query });

	},

};
